import * as React from "react"
import { useTheme } from "../../ThemeContext";
const IconTenantAgreements = (props) => {
    const { theme } = useTheme();
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={63}
            height={62}
            fill="none"
            {...props}
        >
            <rect width={62} height={62} x={0.333} fill={theme === 'dark' ? "#37395B" : "#E7F0FE"} rx={31} />
            <path
                stroke={theme === 'dark' ? "#9aa1a7" : "#6C6C82"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M14.5 47.5h33m-22-23.833h1.833M25.5 31h1.833M25.5 38.333h1.833m7.334-14.666H36.5M34.667 31H36.5m-1.833 7.333H36.5M18.167 47.5V18.167a3.667 3.667 0 0 1 3.666-3.667h18.334a3.667 3.667 0 0 1 3.666 3.667V47.5"
            />
        </svg>
    )
}
export default IconTenantAgreements
